(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aya-customer-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aya-review-carousel')) {
  customElements.define('aya-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('.aya-feedback-card')];
      if (this.cards.length < 2) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || Boolean(window.Shopify && Shopify.designMode);
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.stage = this.querySelector('.aya-feedback-stage');
      this.addEventListener('pointerenter', () => {this.hovered = true; this.sync();}, options);
      this.addEventListener('pointerleave', () => {this.hovered = false; this.sync();}, options);
      this.addEventListener('focusin', () => {this.focused = true; this.sync();}, options);
      this.addEventListener('focusout', (event) => {if (!this.contains(event.relatedTarget)) {this.focused = false; this.sync();}}, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {if(this.motion.matches) this.paused = true; this.sync();}, options);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0) {this.paused = true; this.show(index); this.sync();}
      }, options);
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting; this.sync();}, {threshold:0.25});
      this.observer.observe(this);
      this.sync();
    }
    show(index) {
      this.index = (index + this.cards.length) % this.cards.length;
      this.cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === this.index);
        card.setAttribute('aria-hidden', String(i !== this.index));
      });
    }
    sync() {
      clearInterval(this.timer);
      const running = !this.paused && !this.hovered && !this.focused && this.visible && !document.hidden;
      this.stage.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      if (running) this.timer = setInterval(() => this.show(this.index + 1), 4000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aya-home-screen"] && !Shopify.designMode) return;
  try {
    (() => {
  const banner = document.getElementById('aya-home-screen');
  const guide = document.getElementById('aya-home-screen-guide');
  if (!banner || !guide) return;

  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isAndroid && !isIOS) return;

  if (isAndroid) {
    const androidCopy = [
      'Open your browser menu (usually ⋮ in the top right).',
      'Choose Add to Home screen or Install app.',
      'Tap Add or Install to confirm.'
    ];
    guide.querySelectorAll('[data-aya-home-step]').forEach((step, index) => {
      if (androidCopy[index]) step.textContent = androidCopy[index];
    });
    const note = guide.querySelector('[data-aya-home-note]');
    if (note) note.textContent = 'If you do not see the option, open this page in Chrome and try again. Menu wording can vary slightly by Android version.';
  }

  const standalone = window.matchMedia('(display-mode: standalone)');
  const mobile = window.matchMedia('(max-width: 850px)');
  const key = 'aya-home-screen-dismissed-v1';
  const period = 30 * 24 * 60 * 60 * 1000;
  let dismissed = false;
  let ready = false;
  let interacted = false;
  const isApp = () => navigator.standalone === true || standalone.matches;
  const storedDismissal = () => {
    try { return Date.now() - Number(localStorage.getItem(key) || 0) < period; }
    catch (_) { return false; }
  };
  const eligible = () => mobile.matches && !isApp() && !dismissed && !storedDismissal();
  if (!eligible()) return;
  const busy = () => !!document.querySelector('dialog[open], .menu-drawer-container[open], .aya-mobile-menu[open], .aya-site-menu[open], .aya-collection-menu[open], cart-drawer.active, .search-modal[open]') || /overflow-hidden/.test(document.body.className) || /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
  const refresh = () => { banner.hidden = !eligible() || !ready || !interacted || busy() || document.hidden; };
  const remember = () => {
    dismissed = true;
    try { localStorage.setItem(key, String(Date.now())); } catch (_) {}
    banner.hidden = true;
  };
  const closeGuide = () => { remember(); guide.close(); };
  banner.querySelector('.aya-home-screen__close').addEventListener('click', remember);
  banner.querySelector('.aya-home-screen__how').addEventListener('click', () => {
    if (!eligible()) return;
    guide.showModal();
    banner.hidden = true;
  });
  guide.querySelector('.aya-home-screen__close').addEventListener('click', closeGuide);
  guide.querySelector('.aya-home-screen-guide__done').addEventListener('click', closeGuide);
  guide.addEventListener('cancel', remember);
  guide.addEventListener('click', event => {
    const rect = guide.getBoundingClientRect();
    if (event.target === guide && (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right)) closeGuide();
  });
  const interaction = () => { interacted = true; refresh(); };
  window.addEventListener('scroll', interaction, { passive: true });
  document.addEventListener('pointerdown', interaction, { passive: true });
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('focusin', refresh);
  document.addEventListener('focusout', () => setTimeout(refresh, 0));
  const onDisplayChange = () => { if (!eligible() && guide.open) guide.close(); refresh(); };
  mobile.addEventListener('change', onDisplayChange);
  standalone.addEventListener('change', onDisplayChange);
  window.addEventListener('appinstalled', () => { remember(); if (guide.open) guide.close(); });
  window.addEventListener('storage', onDisplayChange);
  const observer = new MutationObserver(refresh);
  observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
  setTimeout(() => { ready = true; refresh(); }, 15000);
})();
  } catch(e) { console.error(e); }
})();

})();
